import { useMemo, useState } from "react";
import { TableHead } from "@/components/ui/table";
import { ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";

// Reusable client-side sort. accessors: { key: (row) => value }
export const useSortable = (rows, accessors, initial = null) => {
  const [sortKey, setSortKey] = useState(initial);
  const [dir, setDir] = useState("asc");
  const toggle = (key) => {
    if (sortKey === key) setDir((d) => (d === "asc" ? "desc" : "asc"));
    else { setSortKey(key); setDir("asc"); }
  };
  const sorted = useMemo(() => {
    if (!sortKey || !accessors[sortKey]) return rows;
    const acc = accessors[sortKey];
    const arr = [...rows].sort((a, b) => {
      const va = acc(a), vb = acc(b);
      if (typeof va === "number" && typeof vb === "number") return va - vb;
      return String(va ?? "").localeCompare(String(vb ?? ""), undefined, { numeric: true });
    });
    return dir === "desc" ? arr.reverse() : arr;
  }, [rows, sortKey, dir, accessors]);
  return { sorted, sortKey, dir, toggle };
};

export const SortableTh = ({ label, sortKey, activeKey, dir, onSort, className = "", testid }) => (
  <TableHead className={className}>
    <button type="button" onClick={() => onSort(sortKey)} data-testid={testid || `sort-${sortKey}`}
      className="inline-flex items-center gap-1 font-medium hover:text-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded"
      aria-label={`Sort by ${label}`}>
      {label}
      {activeKey === sortKey
        ? (dir === "asc" ? <ArrowUp className="w-3.5 h-3.5 text-primary" /> : <ArrowDown className="w-3.5 h-3.5 text-primary" />)
        : <ChevronsUpDown className="w-3.5 h-3.5 opacity-40" />}
    </button>
  </TableHead>
);
